<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands = [
    {"num_cand":"U2FsdGVkX1/zAKknfNLc4clnitzkEIeZgk/XFCZoV64=","cpf":"U2FsdGVkX1/dq2QhB6hk/9FXjJuYPqBJo32eM+UJEag="},{"num_cand":"U2FsdGVkX18EoMIkVLNFbPJpgAb2/dqlHWKEMkgy8XU=","cpf":"U2FsdGVkX1+ccCyyM/+plWxExcD7nDGa+T6PQbp5DfA="},{"num_cand":"U2FsdGVkX18XqjL3uz5ErIsjRPzdNxM4DxopfyEOx6I=","cpf":"U2FsdGVkX183nvQuU2lsC18S2ulSztewoK8Vrz/Dssc="},{"num_cand":"U2FsdGVkX1/PXzGlrYYIXmnYlozwX0VUYgzNWXGasRU=","cpf":"U2FsdGVkX19QMdLvpHMA7WavekgMevjAnQ8N9bYFEgc="},{"num_cand":"U2FsdGVkX1/Ew+zaMhhKirwZFNLWyfP7J7oxF/45Sm8=","cpf":"U2FsdGVkX18s4ORxauBX35MuRKO5MvKe+wEq+Hx5CZ8="},{"num_cand":"U2FsdGVkX1+5MLEo1pgYe1rnRkYvqSL7HtrBGnjPVUA=","cpf":"U2FsdGVkX19dnUK8V7qjtqwOEWJBFZjEyR2SGTYi6Bc="},{"num_cand":"U2FsdGVkX1/Qn+ZgNaPvxjsKZCNneFzZhivfcoiItbQ=","cpf":"U2FsdGVkX18wKuZIPhI1UQ+0VvlMd9UQ1S0P9Vi6Iks="},{"num_cand":"U2FsdGVkX19gJGcq6xTX/y15ffKWZpYjKjrJQ23zQyg=","cpf":"U2FsdGVkX19/yq/PVrB+/3+2Av/TSyomUn1GsFc7YAY="},{"num_cand":"U2FsdGVkX18kYDG2eZnY4sVAZKfztYkhGtMzScP8uHw=","cpf":"U2FsdGVkX19q+LZWPaNb1BV8aILZXFTOms+b99Pwk8o="},{"num_cand":"U2FsdGVkX1+Gfcd45g0xPGA3NY8NgIiCfn6d7pPAuMo=","cpf":"U2FsdGVkX19/JLIeTBYDt9aQCTrl94okIA+QT77XPXM="},{"num_cand":"U2FsdGVkX1+jAbO/sg3emVgQw80Nr4i1sjw9GpvAk1I=","cpf":"U2FsdGVkX1+7lMvfuvvGl5hyTwj3V1at3AtFBLrPNLg="},{"num_cand":"U2FsdGVkX19OvPcqIA8GTT57Zz+sLyKKPkGS2BT63vE=","cpf":"U2FsdGVkX18Xu/GeM/kB/oBY7KVc7JqLKPvNTMfxHaw="},{"num_cand":"U2FsdGVkX1+0uXCJ0bNY4pRI4e9UgGizCW/eOatPJLs=","cpf":"U2FsdGVkX1+xCfVBxwPZjZ/9D6IGsYwU2lK+d5npv+w="},{"num_cand":"U2FsdGVkX1+q39K9Fc2wQIn2DNYfC7s8rfRxjjjGfzc=","cpf":"U2FsdGVkX18JtAmxpnVEuzgKj0oKZINeVuKIKDuc5dA="},{"num_cand":"U2FsdGVkX1892zxnAqcj0fohD0+OBd3k9agg5KFHTE0=","cpf":"U2FsdGVkX1/4e9ptlLHdI1kejtdt7lk8a48Ppd15JMQ="},{"num_cand":"U2FsdGVkX1+pDqBGGweUM0JrqWZF1SE602dCyal0V5I=","cpf":"U2FsdGVkX19btnFPGgMQG0S4AzO/NrWbhNtx8VOOJYU="},{"num_cand":"U2FsdGVkX19Z10KipP95glSqfpKmYwF68dpy7O4VgrI=","cpf":"U2FsdGVkX19dQgnBPccEQ6rsHTYFKwLz0FC+pvDC3/Y="},{"num_cand":"U2FsdGVkX19a5Ig2tGq2uSGm8UbzOFw6AtVI3zgs15g=","cpf":"U2FsdGVkX18yrqQZKCx/4Xg5SGYQY6lsSg/23AUJPXU="},{"num_cand":"U2FsdGVkX1/m3LPedygVr1FLlLqMcU1e4ZQ8gcFWByE=","cpf":"U2FsdGVkX1/FwW6RXdkL4BlEo18psU4kC/NdNZnfisQ="},{"num_cand":"U2FsdGVkX1+C42PkbNS7jUv4MfxKZupn+uWylkR9Z+o=","cpf":"U2FsdGVkX1/tJtdRS4296BVe9NXlmbBh1myehhHjpU4="},{"num_cand":"U2FsdGVkX1/JAqrdEmnaHo+2e+22CWsS1Pa7kv4mZBc=","cpf":"U2FsdGVkX1+p5pKtudTFZ2VGlOknKUy8JoxxNGDj3jw="},{"num_cand":"U2FsdGVkX19Vbx8GpUF4g+udObHYFAPa400aYDr1Pek=","cpf":"U2FsdGVkX1/qwL8lVbVEBAJrWh0bW00kpQSx2IZanSw="},{"num_cand":"U2FsdGVkX1+ZXH2CvWS+1Ev5L0fG+I75rXn0Qchdou0=","cpf":"U2FsdGVkX1+OHJae6T6DnvI1BeZdIs2wRFUpP+1im2g="},{"num_cand":"U2FsdGVkX18flQpwMHE+suQQQcVFCgGN+Mxo3Qk/ABQ=","cpf":"U2FsdGVkX18gzGhN7lKTxyeQZ48719YMxO+tGX42KWs="},{"num_cand":"U2FsdGVkX1/Gfo4PZi6XHqoW8+BEOJ6O0iUBi1+nFuI=","cpf":"U2FsdGVkX1+c/giTjxL4qyTOxRulGi0iYDpPNwCR+3s="},{"num_cand":"U2FsdGVkX1+GeZazONGS0UVEQ+nYzDzjiLgWafOCOEA=","cpf":"U2FsdGVkX1+e4Pb/swdzuvHKNSjjJ0PrM2xSJLJs4og="},{"num_cand":"U2FsdGVkX18PoQwbM9VsVGplfM85wn2EpaVmanLKRJA=","cpf":"U2FsdGVkX19CtmXy+QNlt7AzVRXJjNXJJ62l2ZScWe8="},{"num_cand":"U2FsdGVkX18Cn0RAwP8VwWpJz075upvWprY5cg3+pXY=","cpf":"U2FsdGVkX19fP2UMc0eQYcVNglG1gCsaFu5xzPCSUII="},{"num_cand":"U2FsdGVkX1/PnsHlxmFT+PpBIfdawEaKFs/5VJcKq8Q=","cpf":"U2FsdGVkX19EHUZeGNnixI8Bq+L7eBm1tYp31lO1JcQ="},{"num_cand":"U2FsdGVkX19BOGv9lwTOLZP0brisnzhYyWS6h0G8GCA=","cpf":"U2FsdGVkX1/ix/3nTFhAMhhzoyOgs7ZWJ6wPuDV5wos="}]


      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2207/rec_insc/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
